import { spawn } from "node:child_process";
import { LocalCliError } from "./errors.js";

/** Run an `azd` CLI command, resolving stdout. Throws LocalCliError on failure. */
export function runAzd(args: string[]): Promise<string> {
  return new Promise((resolve, reject) => {
    const proc = spawn("azd", args, { stdio: ["ignore", "pipe", "pipe"] });
    const out: Buffer[] = [];
    const err: Buffer[] = [];
    proc.stdout.on("data", (d: Buffer) => out.push(d));
    proc.stderr.on("data", (d: Buffer) => err.push(d));
    proc.on("error", (e) => {
      if ((e as NodeJS.ErrnoException).code === "ENOENT") {
        reject(
          new LocalCliError({
            code: "AZD_NOT_INSTALLED",
            message: "The 'azd' command is not installed or not on PATH.",
            hint: "Install the Azure Developer CLI: https://aka.ms/azd-install",
          }),
        );
        return;
      }
      reject(e);
    });
    proc.on("close", (code) => {
      if (code !== 0) {
        reject(
          new LocalCliError({
            code: "AZD_COMMAND_FAILED",
            message: `'azd ${args.join(" ")}' failed: ${Buffer.concat(err).toString("utf8").trim()}`,
          }),
        );
        return;
      }
      resolve(Buffer.concat(out).toString("utf8"));
    });
  });
}

/** True when azd is configured to reuse the az CLI login. False if unset/errored. */
export async function getAzdFollowsAz(): Promise<boolean> {
  try {
    const out = await runAzd(["config", "get", "auth.useAzCliAuth"]);
    return out.trim().replace(/^"|"$/g, "") === "true";
  } catch {
    return false;
  }
}

export async function setAzdFollowAz(): Promise<void> {
  await runAzd(["config", "set", "auth.useAzCliAuth", "true"]);
}
